var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Create a new scenario")]),_c('scenario-form',{attrs:{"data":_vm.scenario,"show-back-button":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }